import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import _ from 'lodash';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
`;

const Item = styled.div`
    position: relative;
    display: flex;
    align-items: stretch;
    color: ${props => props.theme.color};

    &.pls_highlight {
        color: ${props => props.theme.content.accentColor};
    }

    & > * {
        z-index: 2;
    }
    .tl-title {
        font-size: 18px !important;
        font-weight: normal !important;
        text-transform: uppercase;
        flex-grow: 1;
    }

    .tl-image {
        margin: 0 20px;
        width: 60px;
    }
    .list-player-name {
        line-height: 60px;
        text-transform: uppercase;
        flex-grow: 1;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        z-index: 3;
        font-size: 32px;
        span {
            margin-right: 5px;
        }
    }
    .tl-score {
        line-height: 60px;
        min-width: 80px;
        text-align: right;
        font-size: 48px;
        margin: 0 20px;
        white-space: nowrap;
        position: relative;
        z-index: 3;
    }
    .tl-unit {
        font-size: 22px;
    }
`;
const FirstItem = styled(Item)`
    color: ${props => props.theme.color};

    &.pls_highlight {
        color: ${props => props.theme.content.accentColor};
    }
`;

const Header = ({ valueTitle }, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');
    return null;
    return (
        <Item>
            <div className="tl-image" />
            <div className="list-player-name tl-title">{i18('name', lang)}</div>
            <div className="tl-score  tl-title">{valueTitle}</div>
        </Item>
    );
};

const SpecialRow = ({ player, seasonId, rank, highlightFirstPlayer, highlightTeam }) => {
    var name = RCore.getFirstLastName(player.name);
    return (
        <FirstItem
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''}
        >
            <div className="list-player-name">
                <span>
                    {rank}. {name.firstName}
                </span>
                <b>{name.lastName}</b>
            </div>
            <div className="tl-score">
                {player.displayValue || player.value} <span className="tl-unit">{player.unit}</span>
            </div>
        </FirstItem>
    );
};

const StandardRow = ({ player, seasonId, rank, highlightTeam }) => {
    var name = RCore.getFirstLastName(player.name);
    return (
        <Item key={player.id} className={highlightTeam === player.teamId ? 'pls_highlight' : ''}>
            <div className="list-player-name">
                {rank}. {name.firstName} <b>{name.lastName}</b>
            </div>
            <div className="tl-score">
                {player.displayValue || player.value} <span className="tl-unit">{player.unit}</span>
            </div>
        </Item>
    );
};

const Row = ({ player, rank, seasonId, highlightFirstPlayer, highlightTeam }) => {
    var name = RCore.getFirstLastName(player.name);
    if (rank === 0)
        return (
            <SpecialRow
                player={player}
                rank={rank + 1}
                seasonId={seasonId}
                highlightFirstPlayer={highlightFirstPlayer}
                highlightTeam={highlightTeam}
            />
        );
    return <StandardRow player={player} rank={rank + 1} seasonId={seasonId} highlightTeam={highlightTeam} />;
};

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/PlayersListText.js
 **/